// frontend/src/services/todo.service.ts
import api from './api';
import { Todo } from '../types';

interface CreateTodoData {
  title: string;
  description?: string;
  dueDate?: string;
  completed?: boolean;
  priority?: 'low' | 'medium' | 'high';
  couple: string;
  assignedTo?: string;
}

const TodoService = {
  createTodo: async (todoData: CreateTodoData): Promise<Todo> => {
    const response = await api.post<Todo>('/todos', todoData);
    return response.data;
  },

  getCoupleTodos: async (coupleId: string): Promise<Todo[]> => {
    const response = await api.get<Todo[]>(`/todos/couple/${coupleId}`);
    return response.data;
  },

  getTodoById: async (id: string): Promise<Todo> => {
    const response = await api.get<Todo>(`/todos/${id}`);
    return response.data;
  },

  updateTodo: async (id: string, todoData: Partial<CreateTodoData>): Promise<Todo> => {
    const response = await api.patch<Todo>(`/todos/${id}`, todoData);
    return response.data;
  },

  deleteTodo: async (id: string): Promise<{ deleted: boolean }> => {
    const response = await api.delete<{ deleted: boolean }>(`/todos/${id}`);
    return response.data;
  },

  completeTodo: async (id: string): Promise<Todo> => {
    const response = await api.patch<Todo>(`/todos/${id}/complete`);
    return response.data;
  },

  uncompleteTodo: async (id: string): Promise<Todo> => {
    const response = await api.patch<Todo>(`/todos/${id}/uncomplete`);
    return response.data;
  }
};

export default TodoService;
